import React, { PureComponent } from 'react'

/**
 *  给组件添加地址锚，防止浏览器返回刷新，并执行浏览器返回事件回调
 */
const withPreventPageReload = (Component, { hashUrl = 'action' } = {}) => {
  const displayName = `withPreventPageReload(${Component.displayName || Component.name})`
  const hashUrlPostfix = `#${hashUrl}`

  const c = class extends PureComponent {
    hashChangeCallBack = (e) => {
      if (e.oldURL.endsWith(hashUrlPostfix)) {
        this.props.onHistoryBack()
        window.removeEventListener('hashchange', this.hashChangeCallBack)
      }
    }

    originalLocationHref

    componentDidMount() {
      this.originalLocationHref = window.location.href
      if (typeof this.props.onHistoryBack !== 'function') {
        throw new Error('must provide onHistoryBack callback to a modal')
      }
      window.location.href = hashUrlPostfix
      window.addEventListener('hashchange',this.hashChangeCallBack)
    }

    componentWillUnmount() {
      if (window.location.href.endsWith(hashUrlPostfix)) {
        window.history.replaceState(null, '', this.originalLocationHref)
      }
      window.removeEventListener('hashchange', this.hashChangeCallBack)
    }

    render() {
      return <Component {...this.props}></Component>
    }
  }
  c.displayName = displayName
  return c
}

export default withPreventPageReload